/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable operator-linebreak */
/* eslint-disable no-confusing-arrow */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable comma-dangle */
/* eslint-disable function-paren-newline */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import {
  CardNome,
  CardPontuacao,
  CardSearch,
  CardUser,
  ContainerLoading,
} from './styles';
import Header from '../../components/header';
import SearchBar from '../../components/searchBar';
import ItemsList from '../../components/itemListPlace';
import Container from '../../components/container';
import { useStyles } from '../../constants/styles';
import axios from '../../services/axiosServicesAgendamentos';
import { PolepositionRanking, Ranking } from '../../interfaces';
import NavCommon from '../../components/navCommon';
import LoadingCommon from '../../components/LoadingCommon';

const RankingView = () => {
  const [dataToPage, setDataToPage] = useState<Array<PolepositionRanking>>([]);
  const [search, setSearch] = useState<string>();
  const [disabled, setDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [loadingRanking, setLoadingRanking] = useState<boolean>(false);
  const [ranking, setRanking] = useState<Ranking | null>(null);
  const [idPolePosition, setIdPolePosition] = useState<string | null>();
  const history = useHistory();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        '/admin/pole-position/v1/pole-positions-importados'
      );
      const { data } = response?.data;

      setDataToPage(data);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      if (error?.status !== 500) {
        toast.error(
          'Atenção, não foi possível carregar os dados do poleposition!'
        );
      }
    }
  };

  const getRanking = async (id: string) => {
    try {
      setOpenModal(true);
      setLoadingRanking(true);

      const params: {
        idPolePosition: string;
      } = {
        idPolePosition: id,
      };

      const response = await axios.get(
        'admin/pole-position/pontuacoes-corretores/v1/visualizar-pontuacao-posicao-corretores',
        {
          params,
        }
      );

      const { data } = response.data;

      data?.usuarios?.sort((a: any, b: any) =>
        a.posicaoRanking > b.posicaoRanking ? 1 : -1
      );

      setRanking(data);

      setLoadingRanking(false);
    } catch (error) {
      setLoadingRanking(false);
      setOpenModal(false);
      toast.error('Atenção, não foi possível carregar os dados do RANKING!');
    }
  };

  const confirmPolePosition = async () => {
    try {
      setLoadingRanking(true);
      await axios.put(
        `admin/pole-position/pontuacoes-corretores/v1/validar-importacao?idPolePosition=${idPolePosition}`
      );

      toast.success('Importação validada com sucesso!');

      setOpenModal(false);
      setIdPolePosition(null);
      setRanking(null);
      setLoadingRanking(false);
    } catch (error) {
      setLoadingRanking(false);
    }
  };

  return (
    <>
      <NavCommon
        breadcrumbs={[
          { path: '/polipositions', name: 'Pole positions' },
          { path: '', name: 'Ranking' },
        ]}
        showDrop={false}
        isSave={false}
        hasOnChange={false}
        onBack={() => {
          history.goBack();
        }}
        setOpen={() => {}}
        open={false}
        onChange={() => history.push('/novo-poleposition')}
      />
      <Container component="main" maxWidth="xl">
        <div className={useStyles().containerLocal}>
          <Header label="Ranking" />
          {loading ? (
            <ContainerLoading>
              <LoadingCommon />
            </ContainerLoading>
          ) : null}
          <CardSearch>
            {!loading && (
              <SearchBar value={search || ''} setValue={setSearch} />
            )}
          </CardSearch>
          {!loading &&
            dataToPage
              ?.filter((item: PolepositionRanking) => {
                if (search) {
                  return (
                    (item?.nome || '')
                      .toUpperCase()
                      .indexOf(search.toUpperCase()) !== -1
                  );
                }
                return true;
              })
              .map((item: PolepositionRanking) => (
                <ItemsList
                  activeOrInative={() => {}}
                  action={() => {}}
                  type="ranking"
                  key={item?.idPolePosition}
                  setDataToPage={setDataToPage}
                  isActive
                  setDisabled={setDisabled}
                  disabled={disabled}
                  id={item?.idPolePosition}
                  submit={() => {
                    getRanking(item.idPolePosition);
                    setIdPolePosition(item.idPolePosition);
                  }}
                  nome={item?.nome}
                  description={item.descricaoBeneficio || ''}
                  url={item?.urlImagem}
                />
              ))}
        </div>
        <Dialog
          onClose={() => setOpenModal(false)}
          aria-labelledby="customized-dialog-title"
          open={openModal}
        >
          <DialogTitle id="customized-dialog-title">
            Ranking {ranking?.importacaoValidada ? '(Confirmado)' : null}
          </DialogTitle>
          <div style={{ height: '100%', width: 600 }}>
            {loadingRanking ? (
              <ContainerLoading style={{ marginBottom: 40 }}>
                <LoadingCommon />
              </ContainerLoading>
            ) : (
              <>
                <DialogContent dividers>
                  {ranking?.usuarios?.map((item) => (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <CardUser>
                        <CardNome style={{ fontWeight: 'bold' }}>
                          Nome: {item.nomeCorretor}
                        </CardNome>
                        <CardPontuacao
                          style={{ fontWeight: 'bold', marginRight: 10 }}
                        >
                          Posição no ranking: {item.posicaoRanking}
                        </CardPontuacao>
                        <CardPontuacao style={{ fontWeight: 'bold' }}>
                          Pontuação: {item.pontuacaoTotal}
                        </CardPontuacao>
                      </CardUser>
                      <CardNome
                        style={{ marginBottom: 14, fontWeight: 'bold' }}
                      >
                        Critérios:
                      </CardNome>
                      {item?.criterios?.map((it) => (
                        <div
                          style={{
                            flexDirection: 'row',
                            display: 'flex',
                            marginBottom: 6,
                          }}
                        >
                          <CardNome>{it.nome}</CardNome>
                          <CardPontuacao style={{ marginRight: 12 }}>
                            Valor: {it.valor}
                          </CardPontuacao>
                          <CardPontuacao>
                            Pontuação: {it.pontuacao}
                          </CardPontuacao>
                        </div>
                      ))}
                      <div
                        style={{
                          height: 5,
                          backgroundColor: '#6e6e6e',
                          width: '83%',
                          marginTop: 20,
                          marginBottom: 10,
                        }}
                      />
                    </div>
                  ))}
                </DialogContent>
              </>
            )}
          </div>
          <DialogActions>
            {ranking && !loadingRanking && !ranking?.importacaoValidada && (
              <Button
                autoFocus
                onClick={() => confirmPolePosition()}
                color="primary"
              >
                Confirmar POLEPOSITION
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
};
export default RankingView;
